
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_8wgc3_3",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_8wgc3_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_8wgc3_31",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_8wgc3_1",
  "uxdg-inverted": "awsui_uxdg-inverted_1cbgc_8wgc3_53",
  "root": "awsui_root_1cbgc_8wgc3_57",
  "status-error": "awsui_status-error_1cbgc_8wgc3_64",
  "status-warning": "awsui_status-warning_1cbgc_8wgc3_67",
  "status-success": "awsui_status-success_1cbgc_8wgc3_70",
  "status-info": "awsui_status-info_1cbgc_8wgc3_73",
  "status-stopped": "awsui_status-stopped_1cbgc_8wgc3_76",
  "status-pending": "awsui_status-pending_1cbgc_8wgc3_79",
  "status-in-progress": "awsui_status-in-progress_1cbgc_8wgc3_82",
  "status-loading": "awsui_status-loading_1cbgc_8wgc3_85",
  "color-override-red": "awsui_color-override-red_1cbgc_8wgc3_88",
  "color-override-grey": "awsui_color-override-grey_1cbgc_8wgc3_91",
  "color-override-blue": "awsui_color-override-blue_1cbgc_8wgc3_94",
  "color-override-green": "awsui_color-override-green_1cbgc_8wgc3_97",
  "icon": "awsui_icon_1cbgc_8wgc3_3",
  "container": "awsui_container_1cbgc_8wgc3_31"
};
  